export default __webpack_public_path__ + "static/media/MKD.0f20116b.svg";